class Authentication {
  test = () => {};

  setAuthentication = (token, dataUser, customerSelect, email) => {
    localStorage.setItem(
      "EmailUser",
      dataUser[0].Email ? dataUser[0].Email : email,
    );
    localStorage.setItem("token", token);
    localStorage.setItem("dataUser", dataUser[0].UsuarioId);
    localStorage.setItem("UserName", dataUser[0].Nombre);
    localStorage.setItem("UserNameLast", dataUser[0].Apellido);
    localStorage.setItem("RolId", dataUser[0].RolId);
    localStorage.setItem("Rol", dataUser[0].Rol);
    localStorage.setItem("DATAUSER", dataUser.toString());
    localStorage.setItem("customerSelect", JSON.stringify(customerSelect)); // FIXME: quitar
    localStorage.setItem("EnableBoards", dataUser[0].EnableBoards);

    const passwordExpiredData = {
      PasswordExpired: dataUser[0].PasswordExpired,
      Alert: dataUser[0].Alert,
    };

    // localStorage.setItem('PasswordExpired', passwordExpiredData);
    localStorage.setItem(
      "PasswordExpired",
      JSON.stringify(passwordExpiredData),
    );
  };

  getAuthentication = (value) => {
    return localStorage.getItem(value);
  };

  deleteAuthentication = (value) => {
    localStorage.removeItem(value);
  };
}

export default Authentication;
